
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { GameType, GamePayloadType } from "@/common/types/game/game";

export async function gameList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/game/list${queryString}`
    );
}

export async function gameGet(
    game_id: string
) {
    return await clientAxios.get(
        `admin/game/${game_id}/show`
    );
}

export async function gameAdd(
    payload: GamePayloadType
) {
    return await clientAxios.post(
        `admin/game/create`,
        payload
    );
}

export async function gameCopy(
    game_id: string
) {
    return await clientAxios.post(
        `admin/game/${game_id}/copy`,
        null
    );
}

export async function gamePatch(
    game_id: string,
    payload: Partial<GameType>
) {
    return await clientAxios.patch(
        `admin/game/${game_id}/patch`,
        { payload }
    );
}

export async function gameDel(
    game_id: string,
) {
    return await clientAxios.del(
        `admin/game/${game_id}/delete`,
    );
}
